// src/theme/index.js
import { createTheme } from '@mui/material/styles';
import { palette } from './palette';

export const theme = createTheme({
  palette,
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#0a1929',
          borderRight: '1px solid rgba(30, 73, 118, 0.7)'
        }
      }
    }
  }
});